import { render, staticRenderFns } from "./FarmsReliability.vue?vue&type=template&id=4f88f96c"
import script from "./FarmsReliability.vue?vue&type=script&lang=js"
export * from "./FarmsReliability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports